import { ServiceTypeDetailPageStore } from './service-type-detail-page.store';
import { fb, routeParams } from '../../../../modules/shared/shared.global-service';
import { Component, computed, effect, inject, OnDestroy, TemplateRef, viewChild } from '@angular/core';
import { BreadcrumbService } from 'xng-breadcrumb';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { BreadcrumbsEnum } from '../../../../modules/shared/models/breadcrumbs.enum';
import { getServiceTypeFrag } from './service-type-detail-page.query';
import { LayoutService } from '../../../../modules/layout/services/layout.service';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Ripple } from '@openng/optimus-ui/ripple';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { snakeToCamelStr } from '@libs/shared/utils/snake-to-camel';
import { toKebabCase } from '../../../../utils/string.utils';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-service-type-detail-page',
    templateUrl: './service-type-detail-page.component.html',
    styleUrl: './service-type-detail-page.component.scss',
    providers: [ServiceTypeDetailPageStore],
    imports: [
    NgTemplateOutlet,
    Ripple,
    RouterOutlet,
    TranslatePipe,
    NgClass
],
})
export class ServiceTypeDetailPageComponent implements OnDestroy {

    protected readonly store = inject(ServiceTypeDetailPageStore);
    protected readonly breadcrumbs = inject(BreadcrumbService);
    protected readonly layoutService = inject(LayoutService);
    protected readonly route = inject(ActivatedRoute);
    protected readonly router = inject(Router);

    protected readonly url = toSignal(this.router.events);

    protected subsubmenuContent = viewChild<TemplateRef<unknown> | null>('subsubmenuContent');

    protected form = fb.group({});

    protected socialSettingItems = [
        'offers',
    ];

    protected generalSettingItems = [
        'settings',
    ];

    public activeSegment = computed(() => {
        this.url();
        const url = this.router.url;
        if (!url) return '';

        const lookFor = 'service-type/';
        let root = url.substring(url.indexOf(lookFor) + lookFor.length);
        root = root.substring(root.indexOf('/') + 1);
        let index = root.indexOf('/');
        if (index <= 0) index = root.length;

        return snakeToCamelStr(root.substring(0, index));
    });

    constructor() {
        effect(() => {
            this.store.api.getServiceTypes(FilterBuilder.filterById(routeParams.serviceTypeId()), getServiceTypeFrag);
        });

        effect(async () => {
            const parts = this.router.url?.split('/') || [];
            if (!parts.length) return;
            const currentRoute = parts[parts.length - 1];
            if (currentRoute === 'edit') return;
            const allowedKeys = [
                ...(this.store.globalGlobalStore.serviceTypeStore.isSocial() ? this.socialSettingItems : []),
                ...this.generalSettingItems,
            ];
            if (!allowedKeys.length) return;
            if (allowedKeys.includes(currentRoute)) return;
            await this.itemOnClick(allowedKeys[0]);
        });

        effect(() => {
            const type = this.store.serviceType();
            if (!type) return;
            this.store.globalGlobalStore.serviceTypeStore.serviceType.set(type);
            this.breadcrumbs.set(`@${BreadcrumbsEnum.ServiceType}`, `${BreadcrumbsEnum.ServiceType}|${type.name}`);
        });

        effect(() => {
            const menu = this.subsubmenuContent();
            if (!menu) return;
            this.layoutService.setSubsubmenuContent(menu);
        });
    }

    public ngOnDestroy(): void {
        this.layoutService.setSubsubmenuContent(null);
    }

    protected async itemOnClick(path: string): Promise<void> {
        await this.router.navigate([toKebabCase(path)], { relativeTo: this.route });
    }

    protected readonly ServiceTypeEnum = ServiceTypeEnum;
}
